import { replace } from 'connected-react-router';
import { all, fork, put, select, spawn, take } from 'redux-saga/effects';
import { ACCOUNT_DETAILS_SUCCESS, accountDetailsRequest } from '../../modules/account/actions';
import { reConsent } from '../../modules/account/selectors';
import { getPathname } from '../../modules/app/selectors';
import { DEFAULT, HOME, LANDING, LOGIN, LOGIN_CONSENTS } from '../../routes/paths';
import { VIEW_ENTER } from './actions';

/* eslint-disable no-constant-condition */
export function* watchReConsentStatus() {
  const redirectFromPages = [
    DEFAULT,
    LANDING,
    LOGIN,
    LOGIN_CONSENTS
  ];

  while (yield take(ACCOUNT_DETAILS_SUCCESS)) {
    const currentPage = yield select(getPathname);
    const shouldReConsent = yield select(reConsent);
    if (redirectFromPages.includes(currentPage) && !shouldReConsent) {
      yield put(replace(HOME));
    }
  }
}

export function* watchViewEnter() {
  while (yield take(VIEW_ENTER)) {
    yield fork(watchReConsentStatus);
    yield put(accountDetailsRequest());
  }
}

export default function* root() {
  yield all([
    spawn(watchViewEnter)
  ]);
}
/* eslint-enable no-constant-condition */
